import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/ja';
import 'dayjs/locale/kn';
import 'dayjs/locale/nb';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'dayjs/locale/tr';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
